(function () {
  'use strict';

  var output = document.querySelector('[data-lmm-backorder-availability]');
  var dataNode = document.querySelector('[data-lmm-backorder-variants]');
  if (!output || !dataNode) return;

  var data;
  try {
    data = JSON.parse(dataNode.textContent);
  } catch (error) {
    return;
  }

  var states = Object.create(null);
  (data.variants || []).forEach(function (variant) {
    states[String(variant.id)] = variant.backorder === true;
  });

  function render(variantId) {
    if (variantId == null) return;
    output.hidden = states[String(variantId)] !== true;
  }

  function variantIdFromEvent(event) {
    var detail = event && event.detail;
    var variant = detail && (detail.variant || detail.selectedVariant);
    return variant && variant.id ? variant.id : detail && detail.variantId;
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('form[action*="/cart/add"] [name="id"]')) {
      render(event.target.value);
    }
  });

  ['variant:change', 'variant-change', 'product:variant-change'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      render(variantIdFromEvent(event));
    });
  });

  var selectedInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  render(selectedInput ? selectedInput.value : data.selectedVariantId);
})();
